import fakeUsersResponse from '@/mocks/long_term_care/user'
const Mock = {
  'long_term_care/user': () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(fakeUsersResponse)
      }, 500)
    }),
}
import API from '@/assets/js/libs/API'

export default {
  queryUsers: (params) =>
    API.get('long_term_care/user', {
      params: { per_page: 10, current_page: 1, ...params },
    }),
  queryUserDetail: (id) => API.get(`long_term_care/user/search/${id}`),
  searchUsers: (params) =>
    API.get('long_term_care/user/search', {
      params: { telephone: null, mobile_phone: null, name: null, ...params },
    }),
  addNewUser: (formData) =>
    /**
     * Error
     * {"evnet":"postLongTermCareUser","success":false,
     * "error":{"message":"photo 格式需使用 image/jpeg 格式",
     * "type":"FormatError","code":100}}
     *
     * Success
     * {"evnet":"postLongTermCareUser","success":true,"message":"新增長期照護用戶成功","result":true} */
    API.post('long_term_care/user', formData, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }),
  updateUserQRCode: (id) => API.put(`long_term_care/user/qrcode/${id}`),
  updateUser: (id, formData) =>
    /**
     *
     * Success
     * {"event":"putUserData","success":true,"message":"更改長期照護用戶資料成功","result":true} */
    API.put(`long_term_care/user/${id}`, formData, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }),
  getUserById: (id) =>
    API.get(`long_term_care/user/${id}`).then((raw) => {
      const parseGps = (obj) => {
        const { gps, addressGps } = obj
        if (!gps && addressGps) {
          obj.gps = addressGps
          delete obj.addressGps
        }
        return obj
      }

      raw.result = parseGps(raw.result)
      return raw
    }),
  getUserAddressGps: (id) => API.get(`long_term_care/user/address/${id}`),
  deleteUser: (id) => API.delete(`long_term_care/user/${id}`),

  /**
   * 計算長照補助金額
   */
  getSubsidyAmount: (id, params) =>
    API.get(`long_term_care/user/fare/${id}`, { params }),

  /**
   * params:
   * suv: Boolean
   * wheelchair: Boolean
   * highBackWheelchair: Boolean
   * driver_name: String
   * call_number: String
   * */
  searchDriver: (params) => API.get('long_term_care/order/driver', { params }),
  getTeamAvailableServices: (params) =>
    API.get('long_term_care/team/service', { params }),
  queryOrders: (params) =>
    API.get('long_term_care/order/all', {
      params: { order_status: 6, per_page: 10, current_page: 1, ...params },
    }),
  createOrder: (data) => API.post('long_term_care/order', data),
  makeupOrder: (data) => API.post('long_term_care/order/fill', data),
  updateOrder: (id, formData) =>
    API.put(`long_term_care/order/${id}`, formData, {}),
  /**
   *
   * only update order of driver info
   */
  updateOrderAssignDriver: (id, driverId, licenseNumber) =>
    API.put(`long_term_care/order/assign_driver/${id}`, {
      driverId,
      licenseNumber,
    }),
  /**
   * order_status refer to defaultOption
   */
  updateOrderStatus: (id, status = 3) =>
    API.put(`long_term_care/order/status/${id}`, { status }),
  cancelOrder: (id, cancelReason) =>
    API.put(`long_term_care/order/cancel/${id}`, { cancelReason }),
  getOrderById: (id) =>
    API.get(`long_term_care/order/${id}`).then((raw) => {
      // FIXME: GET long_term_care/:id 資料結構跟其他 API 不同
      const parse = (obj) => {
        const {
          driverId,
          callNumber = '呼號',
          licenseNumber,
          name: driverName,
          firstContactNumber: driverFirstContactNumber,
          secondContactNumber: driverSecondContactNumber,
          taximeterNumber: driverTaximeterNumber,
        } = obj.driverInformation

        const _flattenDriverInfo = {
          driverId,
          callNumber,
          licenseNumber,
          driverName,
          driverFirstContactNumber,
          driverSecondContactNumber,
          driverTaximeterNumber,
        }

        return {
          ...obj,
          ...obj.userInformation,
          ...obj.rideInformation,
          ...obj.fareInformation,
          ..._flattenDriverInfo,
          ...obj.immediateInformation,
          note: obj.rideInformation.serviceNote,
          driver: driverId
            ? {
                ...obj.driverInformation,
                callNumber,
                id: driverId,
              }
            : null,
        }
      }

      raw.result = parse(raw.result)

      return raw
    }),
  deleteOrder: (id) => API.delete(`long_term_care/order/${id}`),
  getOrderTotal: () => API.get(`long_term_care/order/total`),
  //long_term_care/order/search/daily_record?start_date=2020-08-01&end_date=2020-09-30&current_page=1&driver_name=我是多元&license_number=das
  searchDateAndDriveInfo: (start, end, driverName, licence) =>
    API.get(
      `long_term_care/order/search/daily_record?start_date=${start}&end_date=${end}&driver_name=${driverName}&license_number=${licence}&current_page=1`,
    ),
}



// WEBPACK FOOTER //
// ./src/API/longTermCareService.js